import { Info } from 'lucide-react';
import { CalloutList } from '../shared/GroupedCallout';
import { SectionHeader, EmptyState } from '../shared/InfoGrid';
import type { OtherServiceInfo } from '../utils/types';

interface OtherServiceInfoTabProps {
  otherServiceInfos: OtherServiceInfo[];
}

export function OtherServiceInfoTab({ otherServiceInfos }: OtherServiceInfoTabProps) {
  if (!otherServiceInfos || otherServiceInfos.length === 0) {
    return (
      <EmptyState
        icon={<Info className="h-6 w-6" />}
        title="No OSI data"
        description="This booking doesn't contain any Other Service Information"
      />
    );
  }

  return (
    <div>
      <SectionHeader
        title="Other Service Information"
        icon={<Info className="h-5 w-5" />}
        count={otherServiceInfos.length}
      />

      <CalloutList
        items={otherServiceInfos}
        renderContent={(osi) => (
          <div className="flex items-start gap-2">
            <span className="inline-flex items-center px-1.5 py-0.5 rounded font-mono text-xs font-semibold bg-slate-100 text-slate-600 shrink-0">
              {osi.airlineCode}
            </span>
            <span className="flex-1">{osi.freetext}</span>
          </div>
        )}
        getBorderColor={() => 'border-l-slate-400'}
      />
    </div>
  );
}
